export default __webpack_public_path__ + "static/media/close.4128ea2d.svg";